const Shimmer = () => {
    return (
        <div className='shimmer'>
            
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div>
            <div className='shimmer-item'></div> 
        </div>
    );
}

export default Shimmer;